import { render, staticRenderFns } from "./PayNotify.vue?vue&type=template&id=3c286e13"
import script from "./PayNotify.vue?vue&type=script&lang=js"
export * from "./PayNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports